import React, { useEffect } from "react";
import EmailIcon from "@mui/icons-material/Email";
import { Box, Button, IconButton } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {
  TextInput,
  required,
  useUpdate,
  useNotify,
  useRefresh,
  useGetList,
  SelectField,
  SelectInput,
  useCreate,
} from "react-admin";
import { useForm, FormProvider, get } from "react-hook-form";
import { Button as MuiButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { JSONTree } from "react-json-tree";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
// import mail from "../../assets/images/mail.svg";
import InputSelectField from "../../common/InputComponents/InputSelectField";
import InputTextArea from "../../common/InputComponents/InputTextArea";
import LoadingSpinner from "../../common/loadingSpinner";
import { Add, Edit } from "@mui/icons-material";
import { BsPencilFill } from "react-icons/bs";

type SendEmailFormProps = {
  handleClose: () => void;
  editData: any;
};

// validation schema here
const validationSchema = Yup.lazy((value) =>
  Yup.object().shape({
    pre_message: Yup.object()
      .shape({
        value: Yup.string().nullable(),
        label: Yup.string().nullable(),
      })

      .nullable(),

    message: Yup.string()
      .nullable()
      .trim("Message is required!")
      .max(5000, "maximum 5000 characters is required")
      .required("Message is required!")
  })
);

const SendEmailForm = (props) => {
  // call get pre define message data
  const documentId = [2, 1, 11, 10].includes(props.document_id) ? 2 : props.document_id;
  
  const { data: preDefinedMessageList, isLoading: isLoadingMessageLoading } =
    useGetList("getDocumentTypeWiseMessage",{filter:{document_id:documentId}});

  // form initial states
  const form = useForm({
    defaultValues: {
      ...props,
      pre_message: "",
      message: props?.editData.message,
      id: props?.editData?.ID,
      userRole: !!props?.isApplicantTitle ? 'applicant' : 'admin'
    },
    resolver: yupResolver(validationSchema),
  });

  // Destructuring form
  const { register, watch } = form;

  const refresh = useRefresh();
  const notify = useNotify();

  // call usecreate
  const [create, { isLoading, error }] = useCreate();

  // form on submit handler
  // const onSubmit = (value) => {
  //   const { pre_message, message_type, ...rest } = value;
  //     const sendData = { to: value.to, message: value.message };
  //     create(
  //       "sendemailtoapplicant",
  //       { data: sendData },
  //       {
  //         onSettled: (data, error) => {
  //           notify(`Message has been send`, {
  //             type: "success",
  //             anchorOrigin: { vertical: "top", horizontal: "right" },
  //           });
  //           refresh();
  //           props?.handleClose();
  //         },
  //         onError: (e: any) =>
  //           notify(`Operation fail:${e.message}`, {
  //             type: "error",
  //             anchorOrigin: { vertical: "top", horizontal: "right" },
  //           }),
  //       }
  //     );

  // };
  const onSubmit = (value) => {
    // const { message_type, ...rest } = value;
    const sendData = {
      document_id: value.document_id,
      source_id: value.source_id,
      id: value.id || 0,
      trn_id: value.trn_id,
      message: value.message,
      userRole: !!props?.isApplicantTitle ? 'applicant' : 'admin',
      source_type: value.source_type
    };
    // alert("dfddffd")
    create(
      "addCustomValidationMessage",
      { data: sendData },
      {
        onSuccess: (data, error) => {
          notify(`Message has been sent`, {
            type: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
          refresh();
          props?.handleClose();
        },
        onError: (e: any) =>
          notify(`Operation fail:${e.message}`, {
            type: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          }),
      }
    );

  };
  if (isLoadingMessageLoading) return <>Loading...</>;
  return (
    <>
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="row">
            <div className="col-12 mr-b20">
              <InputSelectField
                label="Predefined Message"
                source={`pre_message`}
                options={preDefinedMessageList?.map((item) => ({
                  value: item?.Message,
                  label: item?.Message,
                }))}
                required={false}
                labelAsteriskClass={"color-red"}
                labelClass={"lable-title"}
                requiredClass={{
                  fontSize: "70%",
                }}
                onChangeCallback={(selectedOption) => {
                  const nextMessage = typeof selectedOption?.value === 'string'
                    ? selectedOption.value.trim()
                    : '';

                  form.setValue("message", nextMessage, {
                    shouldValidate: true,
                    shouldTouch: true,
                  });
                }}
                fontsize="14px"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 mr-b30">
              <InputTextArea
                register={"message"}
                label="Validation Message"
                placeholder="Message Text"
                labelClass={"lable-title"}
                labelAsteriskClass={"color-red"}
                additionalInputClass={"cus-control"}
                styleProperty={{ height: "auto" }}
                messageText={false}
                requiredClass={{
                  fontSize: "70%",
                }}
              />
            </div>
          </div>
          <Box display={"flex"} justifyContent={"end"}>
            <Button
              sx={{ mx: 1 }}
              onClick={props.handleClose}
              variant="outlined"
              color="secondary"
              type="button"
            >
              Cancel
            </Button>
            <Button
              startIcon={<BsPencilFill />}
              sx={{ mx: 1 }}
              variant="contained"
              type="submit"
            >
              Update Message
            </Button>
          </Box>
        </form>
      </FormProvider>
      {/* <JSONTree data={preDefinedMessageList} /> */}
      {isLoading ? <LoadingSpinner /> : ""}
    </>
  );
};

export default function EditValidationComment(props) {
  const notify = useNotify();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [update, { data, isLoading, error }] = useUpdate();

  return (
    <>
      <IconButton
        size="small"
        aria-label="edit validation message"
        onClick={handleOpen}
        sx={{ width: 28, height: 28, padding: 0.5, color: 'text.secondary' }}
      >
        <Edit sx={{ fontSize: 22 }} />
      </IconButton>


      <Dialog
        fullWidth
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Validation Message</DialogTitle>
        <DialogContent>
          <SendEmailForm
            handleClose={handleClose}
            // email={props?.record?.length > 0 ? props?.record[0]?.Email : ""}
            {...props}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
